import type {
  WidgetMethodSelectionResponse,
  WidgetPaymentStatusResponse,
  WidgetSessionResponse
} from '../types/state';
import type { WidgetMountOptions } from '../types/config';
import { ApiClient } from './client';

export interface CreateSessionRequest {
  publicKey: string;
  projectCode: string;
  merchantOrderId: string;
  amount: number | string;
  currency: string;
  description?: string;
  customerId?: string;
  customerEmail?: string;
  allowedMethods?: string[];
  meta?: Record<string, unknown>;
}

export interface SelectMethodRequest {
  paymentMethod: string;
}

export class SessionApi {
  constructor(private readonly client: ApiClient) {}

  createSession(options: WidgetMountOptions): Promise<WidgetSessionResponse> {
    const payload: CreateSessionRequest = {
      publicKey: options.publicKey,
      projectCode: options.projectCode,
      merchantOrderId: options.merchantOrderId,
      amount: options.amount,
      currency: options.currency,
      description: options.description,
      customerId: options.customerId,
      customerEmail: options.customerEmail,
      allowedMethods: options.allowedMethods,
      meta: options.meta
    };

    return this.client.post<WidgetSessionResponse>('/api/widget/session', payload);
  }

  selectMethod(paymentUuid: string, paymentMethod: string): Promise<WidgetMethodSelectionResponse> {
    const payload: SelectMethodRequest = {
      paymentMethod
    };

    return this.client.post<WidgetMethodSelectionResponse>(
      `/api/widget/session/${encodeURIComponent(paymentUuid)}/select-method`,
      payload
    );
  }

  getStatus(paymentUuid: string): Promise<WidgetPaymentStatusResponse> {
    return this.client.get<WidgetPaymentStatusResponse>(
      `/api/widget/session/${encodeURIComponent(paymentUuid)}/status`
    );
  }

  cancel(paymentUuid: string): Promise<WidgetPaymentStatusResponse> {
    return this.client.post<WidgetPaymentStatusResponse>(
      `/api/widget/session/${encodeURIComponent(paymentUuid)}/cancel`
    );
  }
}